import { Component, OnDestroy } from '@angular/core';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { ListColumnComponent, ListHeaderComponent, ListRowComponent, ListViewComponent, ListViewDirective, ListViewDynamicDirective } from 'components/layout/list-view/list-view.component';
import { CredentialType } from 'enums/CredentialType';
import { Layout } from 'modules/layout';
import { CustomDatePipe } from 'pipes/custom-date.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { RefreshService } from 'services/data-tracking';
import { DateService } from 'services/date.service';
import { ComponentUrl } from 'services/navigation.service';

@Component({
	selector: 'debug-list-view',
	templateUrl: './debug-list-view.component.html',
	providers: [RefreshService],
	imports: [Layout, CustomInputComponent, ListViewComponent, ListViewDynamicDirective, ListHeaderComponent, ListViewDirective, ListRowComponent, ListColumnComponent, CustomDatePipe]
})
@ComponentUrl('debug-list-view')
@CredentialRequired(CredentialType.AccessDebugViews)
export class DebugListViewComponent implements OnDestroy {

	private onRefresh: Subscription;

	generateNumberOfRows = 100;

	testData1: { string: string, date: Date, number: number }[];
	testData: { string: string, date: Date, number: number }[];
	testDataSmall: { string: string, date: Date, number: number }[];
	testDynamicColumns: string[] = ["Kolonne 1", "Kolonne 2", "Kolonne 3"];
	constructor(private readonly dateService: DateService, readonly refreshService: RefreshService) {

		this.onRefresh = refreshService.onRefresh.subscribe(() => {
			this.testData1 = this.testData1.filter((x: any) => !x.$deleted);
			this.testData1.filter((x: any) => x.$new).forEach((x: any) => { x.$new = false });
		});

		let testData: { string: string, date: Date, number: number }[] = [];
		for (var i = 0; i < 100; i++) {
			testData.push({ string: 'text værdi ' + (i + 1), date: dateService.addDays(dateService.today(), i), number: i+1 });
		}
		this.testData = testData;
		this.testData1 = testData;
		this.testDataSmall = testData.slice(0, 5);
	}

	ngOnDestroy(): void {
		this.onRefresh.unsubscribe();
	}

	generateRows() {
		let testData: { string: string, date: Date, number: number }[] = [];
		for (var i = 0; i < this.generateNumberOfRows; i++) {
			testData.push({ string: 'text værdi ' + (i + 1), date: this.dateService.addDays(this.dateService.today(), i), number: Math.round(Math.random() * 100) });
		}
		this.testData1 = testData;
	}

	appendRows() {
		let testData: { string: string, date: Date, number: number, $new?: boolean }[] = [];
		for (var i = 0; i < this.generateNumberOfRows; i++) {
			testData.push({ string: 'text værdi ' + (i + 1), date: this.dateService.addDays(this.dateService.today(), i), number: Math.round(Math.random() * 100), $new: true });
		}
		this.testData1 = this.testData1.concat(testData);
		this.refreshService.refreshAvailable();
	}

	removeRows() {
		// pick x rows from testData1 randomly to set $deleted
		for (var i = 0; i < this.generateNumberOfRows; i++) {
			let activeRows = this.testData1.filter((row: any) => !row.$deleted);
			if (activeRows.length == 0) return;
			const index = Math.floor(Math.random() * activeRows.length);
			let row = activeRows[index] as any;
			row.$deleted = true;
		}
		this.refreshService.refreshAvailable();
	}

}
